module.exports = __webpack_public_path__ + "static/img/shangchuanchangjingtu2.10e4ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/shangchuanchangjingtu2.png
// module id = mUem
// module chunks = 24